function normalizeError(value: unknown, fallback: Error) {
  return value instanceof Error ? value : fallback;
}

export default normalizeError;
